const becomeSellerSl = {
	breadcrumbs: {
		home: 'මුලපිට',
		becomeSeller: 'විකුණන්නෙකු වන්න'
	},
	hero: {
		title: 'විකුණන්නෙකු වන්න',
		subtitle: 'Grameen Bazar සමඟ ඔබගේ ව්යාපාරය වර්ධනය කර ගන්න',
		cta: 'දැන්ම prārambha କරන්න'
	},
	stats: [
		{ value: '50,000+', label: 'සක්‍රීය විකුණුම්කරුවන්' },
		{ value: '98%', label: 'කාලෝචිත ගෙවීම්' },
		{ value: '300%', label: 'සාමාන්ය විකුණුම් වර්ධනය' },
		{ value: '4.8/5', label: 'විකුණුම්කරුවන්ගේ තෘප්තිය' }
	],
	benefits: {
		title: 'විකුණන්නේ නම් ලාභ',
		items: [
			{ title: 'විකුණුම් වැඩිදියුණු කරන්න', description: 'අපගේ 1M+ පාරිභෝගික විෂය පථය හරහා ඔබගේ නිෂ්පාදන' },
			{ title: 'වැඩි ඉපයීම්', description: 'නිකුත් කමිෂන් සහ වේගවත් ගෙවීම්' },
			{ title: '24/7 සහාය', description: 'අපගේ කැපවූ විකුණුම් සහාය කණ්ඩායම සෑම විටම ඔබ සමඟ' },
			{ title: 'ආරක්ෂිත ගනුදෙනු', description: 'සම්පූර්ණයෙන්ම ආරක්ෂිත සහ පාරදෝශී ගෙවීම් පද්ධතිය' },
			{ title: 'ඉක්මන් සැකසුම', description: 'පැය 24 ඇතුළත ඔබගේ ස්ටෝරය prārambha କරන්න' },
			{ title: 'විකුණුම් විශ්ලේෂණ', description: 'විස්තරාත්මක වාර්තා සහ විකුණුම් අධීක්ෂණය' }
		]
	},
	steps: {
		title: 'කෙසේ prārambha කරන්නේද',
		stepNumbers: ['1', '2', '3'],
		items: [
			{ title: 'ලියාපදිංචි කිරීම', description: 'පුද්ගලික හා ව්යාපාරික තොරතුරු සමඟ ලියාපදිංචි වන්න' },
			{ title: 'සත්‍යතාව පරීක්ෂාව', description: 'පැය 24 ඇතුළත අපගේ කණ්ඩායම සත්‍යාපනය කර අනුමත කරයි' },
			{ title: 'විකුණ්නේ prārambha କරන්න', description: 'නිෂ්පාදන උඩුගත කර විකුණුම් prārambha କරන්න' }
		]
	},
	cta: {
		title: 'අදම ඔබගේ ඩිජිටල් ව්යාපාරය prārambha କරන්න',
		subtitle: 'Grameen Bazar සමඟ එක්ව ඔබගේ ව්යාපාරය නව මට්ටමකට',
		button: 'විකුණුම්කරුවකු ලෙස එක්වන්න'
	},
	transformDreams: {
		title: "ග්රാമීන් බසාර් සමඟ ඔබේ සිහින සාර්ථක කරගන්න",
		content: [
			"ඔබේ ව්‍යාපාරය කෙසේ වර්ධනය වන්නේදැයි සිතුවෙකුත් කරන්න – තමා හඳුනන මුහුණු පමණක් නොව, ඔබව මුල්වරට සොයා ගන්නා සෑම ගමේම නව ගනුදෙනුකරුවන් සමඟත්. ග්රാമීන් බසාර් තුළ, ඔබේ නිෂ්පාදන කිසිදු වෙළඳපොළකින් කලින් මිලදී නොගත් පුද්ගලයන්ගේ දෛනික ජීවිතයේ අංගයක් වේ.",
			"අපගේ शक्तියෙන් පිරුණු වෙළඳ ප්‍රචාරණය ගැඹුරු ග්‍රාමීය ප්‍රජාවලට ළඟා වෙයි, ඔබ වැනි දේශීය වික్రේතෘන් සහය දීමට කැමති අයුතු සහ මිතුරන් එක් කරයි. අපගේ මෑතකාලීන සමීක්ෂණය විස්මයජනක සත්‍යයක් අනාවරණය කළේය: අපගේ ගනුදෙනුකරුවන්ගෙන් සම්පුර්ණයෙන්ම 30% ක් මුල්වරට වෙළඳපොළ ගනුදෙනුකරුවෝ වන අතර, ඔබගෙන් මිලදී ගැනීමට සූදානම් සහ උනන්දුවෙන් සිටී.",
			"මෙය ඔබ කලින් කිසිදා නොපිළිගෙන තිබූ අවස්ථාවකි – ඔබේ අතට නැගෙනුනු පුද්ගලයන් වෙත ළඟා වීම, ඔවුන් ඔබේ කතාවට පිළිගැනීම, සහ ඔබේ විකිණීම් 50% න් 100% න් හෝ වැඩි ප්‍රමාණයකින් වැඩි කිරීම. ග්රാമීන් බසාර් සමග එකතු වන්න – මෙය පමණක්ම වේදිකාවක් නොව, චලනයක් වේ.",
			"එක්වන්න, අපි නව අසාව, අවස්ථා සහ සෞභාග්‍යය ඔබේ පවුලට, ඔබේ ගමට සහ ඔබේ සිහින වෙත ගෙනෙමු. ගනුදෙනුකරුවන් රැඳී සිටිති – දැන් ඔබේ දීප්තිමත් වීමට කාලයයි."
		]
	}
	
};

export default becomeSellerSl;


